import React, { useState } from 'react';
import { useI18n } from '../../i18n/LanguageContext';
import { useMedia } from '../../site/MediaProvider';
import manifest from '../../data/media-manifest.json';
import FadeIn from './FadeIn';

const FALLBACK_NAMES: string[] = (manifest as any).customers?.map((c: any) => c.name) || [];
const BADGE_COLORS = ['#1D2C4D', '#14213A', '#173049', '#25406b', '#264a78', '#1f3358'];

const Logo: React.FC<{ name: string; url?: string }> = ({ name, url }) => {
  const [failed, setFailed] = useState(false);
  if (url && !failed) {
    return <img src={url} alt={name} title={name} height={52} loading="lazy" decoding="async" style={{ height: 52, width: 'auto' }} onError={() => setFailed(true)} />;
  }
  const color = BADGE_COLORS[name.length % BADGE_COLORS.length];
  return <div className="logo-badge" style={{ background: color, color: '#fff' }}>{name}</div>;
};

const Customers: React.FC = () => {
  const { t } = useI18n();
  const { media } = useMedia();
  const list = media.customers.length > 0
    ? media.customers
    : FALLBACK_NAMES.map((name) => ({ name, url: '' }));

  return (
    <section id="customers">
      <div className="container">
        <FadeIn style={{ textAlign: 'center' }}>
          <span className="slabel sl-b">{t('cust.badge')}</span>
          <h2 className="stitle">{t('cust.title')}</h2>
          <p className="ssub" style={{ margin: '0 auto' }}>{t('cust.sub')}</p>
        </FadeIn>
        <div className="customers-grid">
          {list.map((c) => (
            <div className="cust-card" key={c.name}>
              <Logo name={c.name} url={c.url} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Customers;
